import {Component, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserService} from '../../../user/user.service';
import {DbServerErrors} from "../../../shared/interceptors/db-server-errors";
import {DbResponse} from "../../../shared/interceptors/db-response";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import {filter, first} from "rxjs/operators";


@Component({
    selector: 'db-disable-2fa',
    templateUrl: 'disable-2fa.component.html',
    styleUrls: ['disable-2fa.component.scss'],
    standalone: false
})
export class Disable2faComponent extends DialogComponent<null, boolean> implements OnInit {
  public loading: boolean;
  public formSubmitted: boolean;
  public disable2faForm: FormGroup;
  public disable2faRecoveryForm: FormGroup;
  public serverErrors: DbServerErrors;
  public activeBlock: string;


  constructor(
    private _userService: UserService,
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.serverErrors = null;
    this.activeBlock = "google-authenticator";
    this.formSubmitted = false;
    this.disable2faForm = new FormGroup({
      disable2faCode: new FormControl("", [Validators.required])
    });
    this.disable2faRecoveryForm = new FormGroup({
      disable2faRecovery: new FormControl("", [Validators.required])
    });
  }

  public disable2faRecovery() {
    this.formSubmitted = true;
    if (this.disable2faRecoveryForm.valid) {
      this.loading = true;
      this._userService.disable2fa(this.disable2faRecoveryForm.value.disable2faRecovery, true)
        .pipe(filter((response: DbResponse) => !!response),
        first())
        .subscribe((response: DbResponse) => {
          if (response.success) {
            this.result = true;
            this._store.dispatch(new fromStore.LoadUser);
            this.close();
          }
          else {
            this.serverErrors = response.serverErrors;
          }
          this.loading = false;
        });
    }
  }

  public disable2faCode() {
    this.formSubmitted = true;
    if (this.disable2faForm.valid) {
      this.loading = true;
      this._userService.disable2fa(this.disable2faForm.value.disable2faCode)
        .pipe(filter((response: DbResponse) => !!response),
        first())
        .subscribe((response: DbResponse) => {
          if (response.success) {
            this._store.dispatch(new fromStore.LoadUser);
            this.close();
          }
          else {
            this.serverErrors = response.serverErrors;
          }
          this.loading = false;
        });
    }
  }

  public disable2fa(activeBlock) {
    if (activeBlock === 'google-authenticator') {
      this.disable2faCode();
    }
    else {
      this.disable2faRecovery();
    }
  }

  public changeBlock() {
    if (this.activeBlock === "google-authenticator") {
      this.activeBlock = 'google-recovery';
    }
    else {
      this.activeBlock = "google-authenticator";
    }
  }

}
